import { render } from "./ViewCountries.vue?vue&type=template&id=69e53fd3"
import script from "./ViewCountries.vue?vue&type=script&lang=js"
export * from "./ViewCountries.vue?vue&type=script&lang=js"
script.render = render

export default script